export default __webpack_public_path__ + "static/media/elderly-care.9ea1c7e3.jpeg";